<template>
    <div>
        <transition name="modal" v-if="carregando">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
                        <label>Aguarde. Carregando.</label>
                    </div>
                </div>
            </div>
        </transition>
        <div v-else>
            <div v-if="erro">
                <SemPermissao></SemPermissao>
            </div>
            <template v-if="!erro">
                <ExibirOcorrencia :ocorrencia="ocorrencia" :temPermissao="temPermissao" :usuario_logado="usuario_logado" :comentarios="comentarios"/>
            </template>
        </div>
    </div>
</template>

<script>
    import OcorrenciaApi from "../../services/OcorrenciaApi";
    import SemPermissao from "../SemPermissao.vue"
    //import ErroResultados from "../../components/ErroResultados";
    import ExibirOcorrencia from "../../components/ocorrencias/ExibirOcorrencia.vue";
    import metaDados from "../../helpers/metaDados";
    import Auth from '../../services/Auth';

    export default {
        name: "OcorrenciasShow",
        metaInfo() {
            if (!this.ocorrencia) {
                return {};
            }

            let title = this.ocorrencia.titulo;
            const description = this.ocorrencia.titulo;

            return {
                title,
                titleTemplate: "%s - Casa Civil do Estado de Goiás",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        property: "description",
                        content: description,
                    },
                    {
                        vmid: "og:description",
                        property: "og:description",
                        content: description,
                    },
                    {
                        vmid: "og:title",
                        property: "og:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    {
                        vmid: "twitter:description",
                        name: "twitter:description",
                        property: "twitter:description",
                        content: description,
                    },
                    {
                        vmid: "twitter:title",
                        name: "twitter:title",
                        property: "twitter:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    ...metaDados(this.$route),
                ],
            };
        },
        data() {
            return {
                temPermissao: null,
                carregando: true,
                erro: false,
                ocorrencia: null,
                usuario_logado: null,
                comentarios: [],
            };
        },
        components: {
            //ErroResultados,
            SemPermissao,
            ExibirOcorrencia,
        },
        created() {
            this.OcorrenciaApi = new OcorrenciaApi();
            let auth = new Auth();
            this.carregarOcorrencia();
            this.usuario_logado = auth.usuario;
            this.temPermissao = auth.temPermissao;
        },
        watch: {
            $route: function (to, from) {
                if (to.params.id != from.params.id) {
                    this.carregarOcorrencia();
                }
            },
        },
        methods: {
            carregarOcorrencia: async function () {
                try {
                    this.carregando = true;
                    this.erro = false;

                    if (this.OcorrenciaApi.cancelTokens.getOcorrencia) {
                        this.OcorrenciaApi.cancelTokens.getOcorrencia.cancel();
                    }

                    const dadosOcorrencia = await this.OcorrenciaApi.getOcorrencia(this.$route.params.id);
                    const comentarios = await this.OcorrenciaApi.getComentarios(this.$route.params.id);

                    this.ocorrencia = dadosOcorrencia;
                    this.comentarios = comentarios;

                    this.carregando = false;
                } catch (err) {
                    if (this.OcorrenciaApi.isCancel(err)) {
                        return;
                    }
                    console.log(err);

                    this.erro = true;
                    this.carregando = false;
                    this.ocorrencia = null;
                    
                }
            },
        },
        
    };
</script>

<style lang="scss" scoped>
</style>